import { useFulfillmentPlannerContext } from '../context';
import { useIsServiceLocalDelivery } from '../../hooks/use-is-service-local-delivery';
import { isShipFromExternal } from '../../store/csw/csw.fulfillment-plan-to-csw';

/**
 * must be used under a FulfillmentPlannerContextProvider
 * @returns {boolean}
 */
export const useIsLocalDeliveryServiceSelected = () => {
  const { shipFromId, serviceIdAndSellerLabelProviderId } = useFulfillmentPlannerContext();
  const isLocalDelivery = useIsServiceLocalDelivery(serviceIdAndSellerLabelProviderId?.serviceId);
  return isShipFromExternal(shipFromId) ? false : isLocalDelivery;
};
